export const colorz = {
    0: {
        home: 'rgba(108,99,255,1)',
        about: 'rgba(127,255,0,1)',
        projects: 'rgba(255,20,147,1)',
        contact: 'rgba(194,76,246,1)',
        text: 'rgba(70, 80, 90,1)',
        hoverText: 'rgba(250,250,250,1)',
        body: 'rgba(250,250,250,1)',
        highlight: 'rgba(252,110,34,1)',
        border: '3px solid rgba(252,110,34,1)',
    },
    1: {
        home: 'rgba(255,20,147,1)',
        about: 'rgba(255,20,147,1)',
        projects: 'rgba(255,20,147,1)',
        contact: 'rgba(255,20,147,1)',
        text: 'rgba(70, 80, 90,1)',
        hoverText: 'rgba(250,250,250,1)',
        body: 'rgba(127,255,0,1)',
        highlight: 'rgba(255,20,147,1)',
        border: '3px solid rgba(255,20,147,1)',
    },
    2: {
      home: 'rgba(120, 255, 241, 1)',
      about: 'rgba(120, 255, 241, 1)',
      projects: 'rgba(120, 255, 241, 1)',
      contact: 'rgba(120, 255, 241, 1)',
      text: 'rgba(250,250,250,1)',
      hoverText: 'rgba(70, 80, 90,1)',
      body: 'rgba(54, 25, 153, 1)',
      highlight: 'rgba(120, 255, 241, 1)',
      border: '3px solid rgba(120, 255, 241, 1)',
    },
    3: {
      home: 'rgba(255, 72, 56, 1)',
      about: 'rgba(255, 72, 56, 1)',
      projects: 'rgba(255, 72, 56, 1)',
      contact: 'rgba(255, 72, 56, 1)',
      text: 'rgba(250,250,250,1)',
      hoverText: 'rgba(22, 43, 50, 1)',
      body: 'rgba(22, 43, 50, 1)',
      highlight: 'rgba(255, 72, 56, 1)',
      border: '3px solid rgba(255, 72, 56, 1)',
    },
    4: {
      home: 'rgba(250, 230, 45, 1)',
      about: 'rgba(250, 230, 45, 1)',
      projects: 'rgba(250, 230, 45, 1)',
      contact: 'rgba(250, 230, 45, 1)',
      text: 'rgba(25, 20, 20, 1)',
      hoverText: 'rgba(25, 20, 20, 1)',
      body: 'rgba(31, 197, 142, 1)',
      highlight: 'rgba(250, 230, 45, 1)',
      border: '3px solid rgba(250, 230, 45, 1)',
    },
    5: {
        home: 'rgba(22, 31, 109, 1)',
        about: 'rgba(22, 31, 109, 1)',
        projects: 'rgba(22, 31, 109, 1)',
        contact: 'rgba(22, 31, 109, 1)',
        text: 'rgba(250,250,250,1)',
        hoverText: 'rgba(250,250,250,1)',
        body: 'rgba(0, 171, 225, 1)',
        highlight: 'rgba(22, 31, 109, 1)',
        border: '3px solid rgba(22, 31, 109, 1)',
    },
    6: {
      home: 'rgba(251, 129, 34, 1)',
      about: 'rgba(251, 129, 34, 1)',
      projects: 'rgba(251, 129, 34, 1)',
      contact: 'rgba(251, 129, 34, 1)',
      text: 'rgba(225, 226, 226, 1)',
      hoverText: 'rgba(29, 34, 40, 1)',
      body: 'rgba(29, 34, 40, 1)',
      highlight: 'rgba(251, 129, 34, 1)',
      border: '3px solid rgba(251, 129, 34, 1)',
    },
    7: {
      home: 'rgba(27, 160, 152, 1)',
      about: 'rgba(27, 160, 152, 1)',
      projects: 'rgba(27, 160, 152, 1)',
      contact: 'rgba(27, 160, 152, 1)',
      text: 'rgba(222, 185, 146, 1)',
      hoverText: 'rgba(5, 22, 34, 1)',
      body: 'rgba(5, 22, 34, 1)',
      highlight: 'rgba(27, 160, 152, 1)',
      border: '3px solid rgba(27, 160, 152, 1)',
    },
    8: {
      home: 'rgba(0, 0, 0, 1)',
      about: 'rgba(0, 0, 0, 1)',
      projects: 'rgba(0, 0, 0, 1)',
      contact: 'rgba(0, 0, 0, 1)',
      text: 'rgba(0, 0, 0, 1)',
      hoverText: 'rgba(253, 217, 53, 1)',
      body: 'rgba(253, 217, 53, 1)',
      highlight: 'rgba(0, 0, 0, 1)',
      border: '3px solid rgba(0, 0, 0, 1)',
    },
    9: {
      home: 'rgba(251, 144, 57, 1)',
      about: 'rgba(251, 144, 57, 1)',
      projects: 'rgba(251, 144, 57, 1)',
      contact: 'rgba(251, 144, 57, 1)',
      text: 'rgba(225, 226, 226, 1)',
      hoverText: 'rgba(100, 108, 121, 1)',
      body: 'rgba(100, 108, 121, 1)',
      highlight: 'rgba(251, 144, 57, 1)',
      border: '3px solid rgba(251, 144, 57, 1)',
    },
    10: {
      home: 'rgba(250, 39, 66, 1)',
      about: 'rgba(250, 39, 66, 1)',
      projects: 'rgba(250, 39, 66, 1)',
      contact: 'rgba(250, 39, 66, 1)',
      text: 'rgba(55, 56, 51, 1)',
      hoverText: 'rgba(232, 234, 227, 1)',
      body: 'rgba(232, 234, 227, 1)',
      highlight: 'rgba(250, 39, 66, 1)',
      border: '3px solid rgba(250, 39, 66, 1)',
    },
    11: {
      home: 'rgba(37, 38, 105, 1)',
      about: 'rgba(37, 38, 105, 1)',
      projects: 'rgba(37, 38, 105, 1)',
      contact: 'rgba(37, 38, 105, 1)',
      text: 'rgba(225, 226, 226, 1)',
      hoverText: 'rgba(225, 226, 226, 1)',
      body: 'rgba(78, 203, 74, 1)',
      highlight: 'rgba(37, 38, 105, 1)',
      border: '3px solid rgba(37, 38, 105, 1)',
    },
    12: {
      home: 'rgba(5, 244, 183, 1)',
      about: 'rgba(5, 244, 183, 1)',
      projects: 'rgba(5, 244, 183, 1)',
      contact: 'rgba(5, 244, 183, 1)',
      text: 'rgba(225, 226, 226, 1)',
      hoverText: 'rgba(18, 21, 31, 1)',
      body: 'rgba(18, 21, 31, 1)',
      highlight: 'rgba(5, 244, 183, 1)',
      border: '3px solid rgba(5, 244, 183, 1)',
    },
  }